export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5662.30ae02f3.jpg";